/* Yummy Gummy — fixes a real gap in Dawn's own <product-recommendations>
   (assets/global.js) + this project's shared yg-carousel (assets/yg-
   carousel.js): the recommendations element injects its fetched HTML via
   a plain innerHTML swap, which is neither DOMContentLoaded nor a
   "shopify:section:load" event — the only two triggers yg-carousel.js
   listens for. Net effect: a yg-carousel shell rendered INSIDE a
   <product-recommendations> fallback (sections/pdp-related.liquid,
   sections/pdp-cross-sell.liquid's recommendations path) never actually
   gets Swiper initialized — cards render (the fetched HTML itself is
   fine) but with no spaceBetween gap and non-functional arrows, since
   both are Swiper-applied, not CSS.

   Fix: watch each <product-recommendations> for its one-time content
   swap, then dispatch the exact "shopify:section:load" event yg-
   carousel.js already listens for, targeted at that element so its
   existing `init(e.target)` scan finds the newly-inserted carousel.
   Nothing about yg-carousel.js itself needed to change. */
(function () {
  'use strict';

  function watch(el) {
    if (el.__pdpRecoWatched) return;
    el.__pdpRecoWatched = true;

    /* Dawn's own ProductRecommendations (assets/global.js) can fetch and
       swap its innerHTML BEFORE this deferred script even runs — its
       IntersectionObserver has a 400px rootMargin, so a fast/cached
       fetch can resolve while the page is still parsing. A pure
       MutationObserver only catches a swap that happens AFTER it's
       attached, so that race silently left this carousel un-init'd
       (no Swiper, so no JS-applied spaceBetween gap and non-functional
       arrows — the actual bug behind "no gap, cards read as joined").
       Checking for already-present content up front closes that race;
       the observer below still covers the (more common) case where the
       swap happens later, after the user scrolls the section into
       view. */
    if (el.children.length) {
      el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      return;
    }

    var observer = new MutationObserver(function () {
      el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      observer.disconnect();
    });
    observer.observe(el, { childList: true });
  }

  function init(root) {
    (root || document).querySelectorAll('product-recommendations').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
